import React, { useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import useDebounce from '../../hooks/useDebounce';
import { Tooltip } from '../Tooltip';

const TextWrapper = styled('div')<{ width: number }>`
  text-align: inherit;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: ${({ width }) => (width ? `${width}px;` : '100%')};
  display: inline-block;
`;

const TextWrapperStandAlone = styled('div')<{ width: number }>`
  padding-top: 0px;
  text-align: inherit;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: ${({ width }) => (width ? `${width}px;` : '100%')};
  display: inline-block;
`;

const TextWrapperTooltip = styled('div')<{ width: number }>`
  text-align: initial;
  width: fit-content;
  word-wrap: break-word;
  ${({ width }) => width && `min-width: ${width}px;`};
`;

const TextWithTooltip = ({
  forceTooltip,
  text,
  tooltipContent,
  className = 'textWithTooltip',
  width,
  showHideTrigger,
  children,
}: any) => {
  const [resizedCounter, setResizedCounter] = useState(0);

  const myref: any = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const firstElementChild = myref.current?.firstElementChild;
    setShowTooltip(
      myref.current?.scrollWidth > myref.current?.clientWidth ||
        myref.current?.scrollHeight > (myref.current?.clientHeight || 0) + 2 ||
        // in case of rendering html elements, do the check on the first child element
        (firstElementChild &&
          (firstElementChild.scrollWidth > firstElementChild.clientWidth ||
            firstElementChild.scrollHeight > firstElementChild.clientHeight)) ||
        forceTooltip,
    );
  }, [forceTooltip, text, tooltipContent, width, showHideTrigger, children, resizedCounter]);

  const handleResize = useDebounce(() => setResizedCounter(resizedCounter + 1), 100);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tooltipNode = tooltipContent ?? text ?? children;

  return showTooltip ? (
    <Tooltip
      arrow
      placement="top"
      html={
        <TextWrapperTooltip className={className} width={width}>
          {tooltipNode}
        </TextWrapperTooltip>
      }
    >
      <TextWrapper className={className} ref={myref} width={width}>
        {text || children}
      </TextWrapper>
    </Tooltip>
  ) : (
    <TextWrapperStandAlone className={className} ref={myref} width={width}>
      {text || children}
    </TextWrapperStandAlone>
  );
};

export default TextWithTooltip;
